var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-column section",
      staticStyle: { "padding-top": "10px" }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { "padding-top": "5px", height: "100%" },
          attrs: { "label-width": "90px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "spacing",
                  attrs: { no: "1" },
                  model: {
                    value: _vm.pageRadio,
                    callback: function($$v) {
                      _vm.pageRadio = $$v
                    },
                    expression: "pageRadio"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { float: "left" },
                      attrs: { label: "mblNo" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BlNo")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      staticStyle: { float: "left" },
                      attrs: { label: "jobNo" }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BusinessNo")))]
                  )
                ],
                1
              ),
              _c("el-input", {
                staticClass: "spacing",
                staticStyle: { width: "150px" },
                attrs: { no: "2" },
                model: {
                  value: _vm.inputString,
                  callback: function($$v) {
                    _vm.inputString = $$v
                  },
                  expression: "inputString"
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "3" },
                  on: { click: _vm.cloudFileUploadHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.UploadFile")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "4" },
                  on: {
                    click: function($event) {
                      return _vm.queryHandler(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "5" },
                  on: { click: _vm.batchDownloadHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchDownload")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "6" },
                  on: { click: _vm.batchUploadHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchUpload")))]
              )
            ],
            1
          ),
          _c("el-row", { staticStyle: { height: "100%" } }, [
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "padding-top": "5px", height: "100%" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", flex: "1", padding: "10px" },
                  attrs: {
                    "config-module": "9400000",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "grid-params": _vm.gridParams,
                    "check-main-record": false,
                    "deselect-main-record": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: _vm.onGridReady
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        ref: "cargoCloudFileUpload",
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.lob,
          "upload-source": _vm.lob + "BatchUploadFileChild",
          "other-upload-func": _vm.otherUploadFunc
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: function(data) {
            _vm.updateSop(data)
            _vm.refreshPage()
          },
          uploadDoneOtherProcessing: function(p) {
            _vm.getOcrFileHandler(p)
          }
        }
      }),
      _c("cargo-batch-file-upload", {
        ref: "cargoBatchFileUpload",
        attrs: {
          visible: _vm.batchCloudFile.visible,
          job: _vm.batchCloudFile.job,
          lob: _vm.batchCloudFile.lob,
          "batch-upload-data": _vm.batchCloudFile.batchUploadData,
          "upload-source": _vm.lob + "BatchUploadFileChild",
          "other-upload-func": _vm.batchOtherUploadFunc
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchCloudFile, "visible", $event)
          },
          uploadDone: _vm.batchUpdateSop,
          uploadDoneOtherProcessing: function(p) {
            _vm.getOcrFileHandler(p)
          }
        }
      }),
      _vm.fileDetail.isShowingDetailForm
        ? _c("file-detail-form-window", {
            attrs: {
              visible: _vm.fileDetail.isShowingDetailForm,
              "row-data-file-detail": _vm.fileDetail.rowDataFileDetail,
              "show-detail-title": _vm.fileDetail.showDetailTitle
            },
            on: { onClose: _vm.detailClose }
          })
        : _vm._e(),
      _vm.jobListWindow.visible
        ? _c("job-list-window", {
            attrs: {
              visible: _vm.jobListWindow.visible,
              "job-nos": _vm.jobListWindow.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobListWindow, "visible", $event)
              },
              selectJobNoHandler: _vm.selectJobNoHandler
            }
          })
        : _vm._e(),
      _vm.selectBox.visible
        ? _c("select-box-window", {
            attrs: { visible: _vm.selectBox.visible, lob: _vm.selectBox.lob },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectBox, "visible", $event)
              },
              selectBoxCloseHandler: _vm.selectBoxCloseHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }